import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function PhoneRenderer({ value, onChange, readOnly }: FieldRendererProps) {
  return (
    <MaskedTextBox
      mask="(000) 000-0000"
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.value ?? '')}
      disabled={readOnly}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'PHONE',
  label: 'Phone',
  category: 'formatted',
  icon: <FontAwesomeIcon icon={faPhone} fixedWidth />,
  defaultProps: {
    label: 'Phone Number',
    isRequired: false,
  },
  Renderer: PhoneRenderer,
};
